/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  var eventMethod = window.addEventListener
  ? "addEventListener"
  : "attachEvent";
var eventer = window[eventMethod];
var messageEvent = eventMethod === "attachEvent"
? "onmessage"
: "message";
eventer(messageEvent, function (e) {
// if (e.origin !== 'http://the-trusted-iframe-origin.com') return;
console.log('EVENTER',e);
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.



})();

// Başarılı kayıt mesajı sistemi
(function() {
  'use strict';

  // Global değişkenler
  let registrationSuccess = false;
  let registrationError = false;
  let currentUserName = '';

  // Basit log fonksiyonu
  function debugLog(message, data = null) {
    console.log('[Kito Registration]', message, data || '');
  }

  // Form verilerinden kullanıcı ismini yakala
  function captureUserName() {
    const firstNameInput = document.querySelector('input[name*="first_name"], input[name*="firstName"], #first_name, #firstName');
    const lastNameInput = document.querySelector('input[name*="last_name"], input[name*="lastName"], #last_name, #lastName');
    
    let firstName = '';
    let lastName = '';
    
    if (firstNameInput && firstNameInput.value.trim()) {
      firstName = firstNameInput.value.trim();
    }
    
    if (lastNameInput && lastNameInput.value.trim()) {
      lastName = lastNameInput.value.trim();
    }
    
    currentUserName = firstName || lastName ? `${firstName} ${lastName}`.trim() : '';
    
    
    return currentUserName;
  }

  // Hoş geldin modal'ı gösterme fonksiyonu
  function showWelcomeModal(userName = '') {
    
    // Eğer zaten modal varsa gösterme
    const existingModal = document.querySelector('.kito-welcome-overlay');
    if (existingModal) {
      console.log('Modal zaten gösteriliyor, yenisini gösterme');
      return;
    }
    
    // Mevcut modal'ları temizle (güvenlik için)
    const existingModals = document.querySelectorAll('.kito-welcome-overlay, .kito-welcome-modal');
    existingModals.forEach(modal => modal.remove());

    // Dil tespiti
    const isEnglish = window.location.pathname.includes('/en') || document.documentElement.lang === 'en';
    
    // Kullanıcı ismi varsa kullan, yoksa genel mesaj
    const displayName = userName ? userName : (isEnglish ? 'Dear Customer' : 'Değerli Müşterimiz');
    
    // Modal HTML oluştur
    const modalHTML = `
      <div class="kito-welcome-overlay">
        <div class="kito-welcome-modal">
          <div class="kito-welcome-header">
             <div class="kito-welcome-header-title">
               ${isEnglish ? 'Your account has been successfully created.' : 'Hesabınız başarıyla oluşturuldu.'}
             </div>
             <button class="kito-welcome-close" aria-label="Close modal" onclick="this.closest('.kito-welcome-modal').parentElement.remove()">×</button>
           </div>
           
           <div class="kito-welcome-content">
             <div class="kito-welcome-main-text">
               ${isEnglish 
                 ? 'You earn Paw Points equivalent to 20% of every purchase at Kito.' 
                 : 'Kito\'da her alışverişinizin %20\'si kadar<br>Pati Puan hediye.'
               }
             </div>
            
            <div class="kito-welcome-actions">
               <button class="kito-main-btn" onclick="window.location.href='${isEnglish ? '/en/account/login' : '/account/login'}'">
                 ${isEnglish ? 'Log In and Start Shopping' : 'Giriş Yap ve Alışverişe Başla'}
               </button>
            </div>
            
            <div class="kito-welcome-footer">
               ${isEnglish ? 'Thank you for choosing Kito!' : 'Kito\'yu tercih ettiğiniz için teşekkür ederiz!'}
            </div>
          </div>
        </div>
      </div>
    `;

    // Stil ekle
    const style = document.createElement('style');
    style.textContent = `
             .kito-welcome-overlay {
         position: fixed;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         background: rgba(0, 0, 0, 0.5);
         z-index: 10000;
         display: flex;
         align-items: center;
         justify-content: center;
         animation: kitoFadeIn 0.3s ease-out;
       }
      
      .kito-welcome-modal {
        background: #fff;
        border-radius: 12px;
        max-width: 500px;
        width: 90%;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
        animation: kitoSlideUp 0.3s ease-out;
        position: relative;
        overflow: hidden;
      }
      
      .kito-welcome-header {
         background: #457e6f;
         color: white;
         padding: 25px;
         display: flex;
         align-items: center;
         justify-content: center;
         position: relative;
       }
       
       .kito-welcome-header-title {
         text-align: center;
         font-size: 18px;
         font-weight: 500;
         padding: 0 40px;
         line-height: 1.3;
       }
      
      .kito-welcome-close {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: white;
        font-size: 24px;
        width: 35px;
        height: 35px;
        min-width: 35px;
        min-height: 35px;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        box-sizing: border-box;
        transition: background 0.2s ease;
        font-weight: 300;
        line-height: 1;
      }
      
      .kito-welcome-close:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      .kito-welcome-content {
         padding: 40px 30px 30px;
         text-align: center;
       }
       
       .kito-welcome-main-text {
         font-size: 22px;
         color: #333;
         line-height: 1.4;
         margin-bottom: 35px;
         font-weight: 500;
       }
      
      .kito-welcome-actions {
        display: flex;
        justify-content: center;
        margin-bottom: 25px;
      }
      
      .kito-main-btn {
        padding: 15px 40px;
        border-radius: 25px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: none;
        background: #457e6f;
        color: white;
        min-width: 280px;
        box-sizing: border-box;
      }
      
      .kito-main-btn:hover {
        background: #366357;
        transform: translateY(-2px);
      }
      
             .kito-welcome-footer {
         color: #666;
         font-size: 14px;
         margin-top: 10px;
         font-weight: 400;
       }
      
      @keyframes kitoFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      
      @keyframes kitoSlideUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      @media (max-width: 480px) {
        .kito-welcome-modal {
          width: 95%;
          margin: 10px;
        }
        
                 .kito-welcome-content {
           padding: 20px;
         }
         
         .kito-welcome-header-title {
           font-size: 16px;
           padding: 0 35px;
         }
         
         .kito-welcome-text {
           font-size: 13px;
         }
        
        .kito-welcome-actions {
          flex-direction: column;
          gap: 10px;
        }
        
        .kito-main-btn {
          width: 100%;
          min-width: unset;
          justify-content: center;
        }
      }
    `;

    if (!document.querySelector('#kito-welcome-styles')) {
      style.id = 'kito-welcome-styles';
      document.head.appendChild(style);
    }

    // Modal'ı sayfaya ekle
    const modalContainer = document.createElement('div');
    modalContainer.innerHTML = modalHTML;
    document.body.appendChild(modalContainer.firstElementChild);

    // ESC tuşu ile kapatma
    const escapeHandler = (e) => {
      if (e.key === 'Escape') {
        const modal = document.querySelector('.kito-welcome-overlay');
        if (modal) {
          modal.remove();
          document.removeEventListener('keydown', escapeHandler);
        }
      }
    };
    document.addEventListener('keydown', escapeHandler);

    // Overlay'e tıklayınca kapatma
    const overlay = document.querySelector('.kito-welcome-overlay');
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          overlay.remove();
          document.removeEventListener('keydown', escapeHandler);
        }
      });
    }
  }

  // AJAX response interceptor - sadece kayıt sırasında aktif
  function interceptAjaxResponses() {
    // Zaten intercept edilmişse tekrar etme
    if (window.kitoAjaxIntercepted) {
      return;
    }
    
    window.kitoAjaxIntercepted = true;
    
    // XMLHttpRequest intercept
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      this._url = url;
      this._method = method;
      return originalXHROpen.apply(this, [method, url, ...args]);
    };

    XMLHttpRequest.prototype.send = function(data) {
      const xhr = this;
      
      // Customer Account Pro app isteklerini yakala
      if (xhr._url && (xhr._url.includes('customerdashboard') || 
                       xhr._url.includes('customer') || 
                       xhr._url.includes('custlo') ||
                       xhr._url.includes('register') ||
                       xhr._url.includes('account'))) {
        const originalOnReadyStateChange = xhr.onreadystatechange;
        
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            try {
              const response = JSON.parse(xhr.responseText);
                                    
               
               // Sadece Customer Account Pro response formatını kontrol et
               if (response && typeof response === 'object' && response.hasOwnProperty('status') && response.hasOwnProperty('data')) {
                 if (response.status === 200 && response.data) {
                   if (response.data.status === 200) {
                     // Başarılı kayıt
   
                     registrationSuccess = true;
                     registrationError = false;
                     
                     // Kullanıcı ismini kaydet
                     const userName = captureUserName();
                     
                     sessionStorage.setItem('kito_registration_success', 'true');
                     sessionStorage.setItem('kito_registration_timestamp', Date.now().toString());
                     sessionStorage.setItem('kito_user_name', userName);
                     
                     // Kısa bir gecikme ile modal'ı göster
                     setTimeout(() => {
                       showWelcomeModal(userName);
                     }, 1000);
                     
                   } else if (response.data.status === 300 || 
                             (response.data.data && response.data.data.includes('already taken'))) {
                     // Hata durumu - email zaten var
 
                     registrationError = true;
                     registrationSuccess = false;
                     sessionStorage.removeItem('kito_registration_success');
                     sessionStorage.removeItem('kito_registration_attempted');
                   }
                 }
               }
             } catch (e) {
               if (e.message && !e.message.includes('Unexpected end of JSON input')) {
   
               }
             }
          }
          
          if (originalOnReadyStateChange) {
            originalOnReadyStateChange.apply(xhr, arguments);
          }
        };
      }
      
      return originalXHRSend.apply(this, arguments);
    };

    // Fetch API intercept
    const originalFetch = window.fetch;
    window.fetch = function(url, options = {}) {
      return originalFetch(url, options).then(response => {
        // Customer Account Pro app isteklerini yakala
        if (url.includes('customerdashboard') || 
            url.includes('customer') || 
            url.includes('custlo') ||
            url.includes('register') ||
            url.includes('account')) {
                               response.clone().json().then(data => {
            
            
            // Sadece Customer Account Pro response formatını kontrol et
            if (data && typeof data === 'object' && data.hasOwnProperty('status') && data.hasOwnProperty('data')) {
              if (data.status === 200 && data.data) {
                if (data.data.status === 200) {
  
                  registrationSuccess = true;
                  registrationError = false;
                  
                  // Kullanıcı ismini kaydet
                  const userName = captureUserName();
                  
                  sessionStorage.setItem('kito_registration_success', 'true');
                  sessionStorage.setItem('kito_registration_timestamp', Date.now().toString());
                  sessionStorage.setItem('kito_user_name', userName);
                  
                  // Kısa bir gecikme ile modal'ı göster
                  setTimeout(() => {
                    showWelcomeModal(userName);
                  }, 1000);
                  
                } else if (data.data.status === 300 || 
                          (data.data.data && data.data.data.includes('already taken'))) {
                  
                  registrationError = true;
                  registrationSuccess = false;
                  sessionStorage.removeItem('kito_registration_success');
                  sessionStorage.removeItem('kito_registration_attempted');
                }
              }
            }
          }).catch(e => {
            // Sadece gerçek parse hatalarını logla
            if (e.message && !e.message.includes('Unexpected end of JSON input')) {

            }
          });
        }
        return response;
      });
    };
  }

  // Form submit handler - AJAX interceptor'ı sadece gerektiğinde başlat
  function setupFormSubmitHandler() {
    const registerForms = document.querySelectorAll('form[action*="customer"], form[action="/account"], form[action*="/register"]');
    
    registerForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        
        // Kullanıcı ismini yakala
        const userName = captureUserName();
        
        // Form submit edildiğinde flag set et
        sessionStorage.setItem('kito_registration_attempted', 'true');
        sessionStorage.setItem('kito_registration_timestamp', Date.now().toString());
        sessionStorage.setItem('kito_user_name', userName);
        
        // AJAX interceptor'ı başlat (eğer henüz başlatılmamışsa)
        if (!window.kitoAjaxIntercepted) {
          interceptAjaxResponses();
        }
        
        registrationSuccess = false;
        registrationError = false;
      });
    });
  }

  // Kayıt durumunu kontrol et
  function checkRegistrationStatus() {
    const urlParams = new URLSearchParams(window.location.search);
    const currentPath = window.location.pathname;
    const hasReturnUrl = urlParams.has('return_url');
    

    
    // Form submit handler artık setupFormSubmitHandler'da yapılıyor

    // Başarılı kayıt kontrolü - SADECE gerçekten başarılı olduğunda
    const registrationSuccessFlag = sessionStorage.getItem('kito_registration_success');
    const timestamp = sessionStorage.getItem('kito_registration_timestamp');
    const timeDiff = timestamp ? Date.now() - parseInt(timestamp) : 0;
    

    
    // Eğer son 30 saniye içinde BAŞARILI kayıt varsa ve şu an account sayfasındaysak
    if (registrationSuccessFlag && timeDiff < 30000) {
      const isAccountPage = currentPath.includes('/account') || currentPath.includes('/customers');
      const hasCustomerInfo = document.querySelector('.customer-logged-in, .account, #Register');
      

      
      if (isAccountPage || hasReturnUrl || hasCustomerInfo) {

        
        // Kaydedilmiş kullanıcı ismini al
        const savedUserName = sessionStorage.getItem('kito_user_name') || '';
        
        // Modal'ı göster
        showWelcomeModal(savedUserName);
        
        // Flag'ları temizle
        sessionStorage.removeItem('kito_registration_success');
        sessionStorage.removeItem('kito_registration_attempted');
        sessionStorage.removeItem('kito_registration_timestamp');
        sessionStorage.removeItem('kito_user_name');
      }
    }

    // URL parametrelerini temizle (opsiyonel)
    if (hasReturnUrl && urlParams.get('return_url') === 'account') {
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);

    }
  }

  // Customer Account Pro app ile entegrasyon
  function setupCustomerAccountProIntegration() {
    // MutationObserver ile DOM değişikliklerini izle
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // Yeni eklenen nodları kontrol et
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Customer Account Pro'nun eklediği elementleri kontrol et
            if (node.querySelector && (
              node.querySelector('[data-custlo]') ||
              node.querySelector('.custlo') ||
              node.classList.contains('custlo') ||
              node.id && node.id.includes('custlo')
            )) {
              // App yüklendikten kısa bir süre sonra kontrol et
              setTimeout(checkRegistrationStatus, 500);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }



  // Sayfa yüklendiğinde çalıştır - SADECE login ve account sayfalarında
  document.addEventListener('DOMContentLoaded', function() {
    // Sayfa kontrolleri - sadece login ve account
    const isAccountPage = window.location.pathname.includes('/account');
    const isLoginPage = window.location.pathname.includes('/login');
    
    // Sadece account veya login sayfalarında çalıştır
    if (isAccountPage || isLoginPage) {
        const hasCustomerAccountPro = document.querySelector('[data-custlo], .custlo, .customerdb-parent, .cdp_register_form, .cdp_user-details');
        const hasRegisterForm = document.querySelector('form[action*="customer"], form[action="/account"], form[action*="/register"]');
        
        // AJAX interceptor'ı başlat
        if (hasCustomerAccountPro || isAccountPage) {
          interceptAjaxResponses();
        }
        
        // Form handler'ı da kur
        if (hasRegisterForm) {
          setupFormSubmitHandler();
        }
        
        checkRegistrationStatus();
        setupCustomerAccountProIntegration();
      }

  });



})();
